import { render, staticRenderFns } from "./IntegracoesApiBC.vue?vue&type=template&id=55938659&scoped=true"
import script from "./IntegracoesApiBC.vue?vue&type=script&lang=js"
export * from "./IntegracoesApiBC.vue?vue&type=script&lang=js"
import style0 from "./IntegracoesApiBC.vue?vue&type=style&index=0&id=55938659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55938659",
  null
  
)

export default component.exports